import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const serviceWrap = document.querySelector('.l-section__feature.top');
const debug = true;
if (!debug) {
    const serviceList = document.querySelector('.l-list__feature');
    const serviceItem = serviceList.querySelectorAll('.c-item__feature');
    const listWidth = serviceList.clientWidth;
    const listScrollWidth = serviceList.scrollWidth;
    const distance = listScrollWidth - listWidth + serviceItem[0].clientWidth / 2;
    let pinTl = gsap.timeline({
        scrollTrigger: {
            scrub: 1,
            trigger: serviceList,
            start: `center center`,
            end: () => '+=' + (window.innerHeight * 2),
            pin: true,
            invalidateOnRefresh: true,
            // markers: true,
        }
    })

    pinTl.to(serviceList, {
        x: -distance,
        duration: 32,
        // ease: "power1.inOut",
    }, '+=1')
}